export default __webpack_public_path__ + "static/media/image_4.b5efee74.jpg";